export default __webpack_public_path__ + "static/media/1_0008.4e12a047.webp";